<template>
  <v-app>
  <!--
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Planetas"
          class="shrink mr-2"
          contain
		 :src="require('./assets/logo.jpg')"
          transition="scale-transition"
          width="40"
        />
		Planetas!
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Ingresar</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>
-->
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  //components: {
  //  HelloWorld,
  //},

  data: () => ({
    //
  }),
};
</script>
